import { Component, OnInit } from '@angular/core';
import { User } from 'src/assets/data/interfaces/interfaces-service';
import { Storage } from '@ionic/storage-angular';
import { ApiService } from '../services/api.service';
import { Router } from '@angular/router';
import * as zxcvbn from 'zxcvbn';
@Component({
  selector: 'app-cambio-contrasenha',
  templateUrl: './cambio-contrasenha.page.html',
  styleUrls: ['./cambio-contrasenha.page.scss'],
})
export class CambioContrasenhaPage implements OnInit {
  actualPassword = '';
  newPassword = '';
  newPasswordAgain = '';
  clientes: any = [];
  user: User = {
    username: null,
    userId: null,
    clientes: null,
    roles: null,
  };
  error = '';
  correcto = '';
  constructor(
    public storage: Storage,
    public apiService: ApiService,
    public router: Router
  ) { }

  ngOnInit() { }

  ionViewWillEnter() {
    this.storage.get("user").then(data => {
      this.user.username = data.username;
      this.user.userId = data.userId;
      this.user.clientes = data.clientes;
      this.user.roles = data.roles;
    });
  }

  passwordStrength(password: string): number {
    if (!password) {
      return 0;
    }
    const result = zxcvbn(password);
    if (result.score == 0) { return 1; }
    return result.score;
  }

  getPasswordStrengthColor(password: string): string {
    const strength = this.passwordStrength(password);
    switch (strength) {
      case 0:
      case 1:
        return 'danger';
      case 2:
        return 'warning';
      case 3:
        return 'success';
      case 4:
        return 'tertiary';
      default:
        return 'medium';
    }
  }

  onSubmit() {
    let params = { "actualPassword": this.actualPassword, "newPassword": this.newPassword, "newPasswordAgain": this.newPasswordAgain }
    this.apiService.cambiarContrasenha(params).subscribe({
      next: () => {
        this.correcto = 'Contraseña cambiada correctamente';
        setTimeout(() => {
          this.storage.remove("private-data");
          this.router.navigateByUrl('/login', { replaceUrl: true })
        }, 1500);
      },
      error: (err) => { return this.error = err.error; }
    });
  }
}

